import React, { SVGProps } from "react";
import { classNames } from "src/common_util";

const Icon = (props: { path: string } & SVGProps<SVGSVGElement>): React.JSX.Element => {
  const { path: _path, ...other } = props;

  return (
    <svg {...other}>
      <use href={props.path} />
    </svg>
  );
}

const StreamlineIcon = (props: {
  href: string,
  additionalClasses?: { [className: string]: boolean }
} & Omit<SVGProps<SVGSVGElement>, "className">): React.JSX.Element => {
  const { href, additionalClasses, ...other } = props;
  const path = `${href}#icon`;

  const classes = classNames({
    "icon": true,
    "streamline-icon": true,
    ...additionalClasses,
  });

  return <Icon {...other} path={path} className={classes} />
}

export { Icon, StreamlineIcon };
